// src/OngletRegles.jsx
import React, { useState } from "react";
import LogoutButton from "./components/LogoutButton.jsx";

export default function OngletRegles() {
  const [section, setSection] = useState("menu");

  const SETTINGS = {
    contentWidth: 1800,
    paragraphSize: 22,
  };

  const S = {
    container: {
      maxWidth: "3000px",
      margin: "0 auto",
      padding: "30px",
      fontFamily:
        "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      textAlign: "center",
    },
    title: { fontSize: "50px", fontWeight: "bold", marginBottom: "100px" },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "60px",
      justifyContent: "center",
    },
    btn: {
      padding: "40px 20px",
      borderRadius: "14px",
      backgroundColor: "#1f2937",
      color: "#fff",
      fontSize: "26px",
      fontWeight: "700",
      cursor: "pointer",
      border: "none",
      boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
      transition: "transform 0.15s",
    },
    backBtn: {
      marginTop: "40px",
      padding: "14px 22px",
      borderRadius: "10px",
      backgroundColor: "#2563eb",
      color: "#fff",
      fontSize: "18px",
      border: "none",
      cursor: "pointer",
      display: "inline-block",
      marginRight: "20px",
    },
    content: {
      width: "100%",
      maxWidth: `min(92vw, ${SETTINGS.contentWidth}px)`,
      margin: "0 auto",
      textAlign: "left",
    },
    paragraph: {
      fontSize: `${SETTINGS.paragraphSize}px`,
      lineHeight: 1.6,
      textAlign: "justify",
      whiteSpace: "pre-line",
      margin: 0,
      maxWidth: "none",
    },
    h2: {
      fontSize: "30px",
      margin: "0 0 28px 0",
      fontWeight: 700,
    },
  };

  // ======== MENU ========
  if (section === "menu") {
    return (
      <div style={S.container}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px" }}>
          <h1 style={S.title}>📘 Règles – Mode d'emploi</h1>
          <LogoutButton style={{ marginTop: "20px" }} />
        </div>

        <div style={S.grid}>
          <button style={S.btn} onClick={() => setSection("generales")}>
            📋 Règles générales
          </button>
          <button style={S.btn} onClick={() => setSection("desiderata")}>
            🗒️ Désidérata de gardes
          </button>
          <button style={S.btn} onClick={() => setSection("repartition")}>
            📊 Répartition des gardes
          </button>
        </div>

        <div>
          <button style={S.backBtn} onClick={() => window.history.back()}>
            ⬅️ Retour à la page d'accueil
          </button>
        </div>
      </div>
    );
  }

  // ======== CONTENU ========
  let contenu = null;

  if (section === "generales") {
    contenu = (
      <div style={S.content}>
        <h2 style={S.h2}>📋 Règles générales</h2>
        <p style={S.paragraph}>
{`Ces règles définissent les obligations de service :
Temps de travail 10 demi-journées hebdomadaires dont 2 demi-journées consacrées à l'activité non clinique (NC).
Le samedi matin est "ouvré" : une présence compte une demi-journée.
Les gardes comptent pour 2 demi-journées en semaine, 3 le samedi et 4 le dimanche.
Repos de sécurité la journée qui suit immédiatement la sortie de garde.
CA (25) et RTT (19) désormais résumé à "CA" : 44 jours soit 88 demi-journées.
Congés formation (CF) : 15 jours "ouvrés" soit 30 demi-journées (avec justificatifs).
Ces règles sont applicables à tous les secteurs et doivent être respectées par l’ensemble de l’équipe médicale.`}
        </p>
      </div>
    );
  }

  if (section === "desiderata") {
    contenu = (
      <div style={S.content}>
        <h2 style={S.h2}>🗒️ Mode d’emploi – Désidérata de gardes</h2>
        <p style={S.paragraph}>
          Chaque médecin doit renseigner ses disponibilités et contraintes pour
          les gardes en respectant la date limite. Il précise le nombre de
          gardes souhaité. Les souhaits sont pris en compte pour la répartition.
          Le nombre est respecté dans la limite des possibilités. Le responsable
          de secteur conserve un droit de validation et d’arbitrage.
        </p>
      </div>
    );
  }

  if (section === "repartition") {
    contenu = (
      <div style={S.content}>
        <h2 style={S.h2}>📊 Mode d’emploi – Répartition des gardes</h2>
        <p style={S.paragraph}>
          La répartition se fait automatiquement à partir des disponibilités
          renseignées et des règles de service. Le responsable de secteur ajuste
          au besoin la liste avant validation définitive et diffusion.
        </p>
      </div>
    );
  }

  // ======== RENDU FINAL ========
  return (
    <div style={S.container}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
        <LogoutButton />
      </div>
      {contenu}

      <div>
        <button style={S.backBtn} onClick={() => setSection("menu")}>
          ⬅️ Retour aux règles
        </button>
        <button style={S.backBtn} onClick={() => window.history.back()}>
          ⬅️ Retour interface Responsable
        </button>
      </div>
    </div>
  );
}